import Svg from '../generated/Info';
import { Icon, type IconProps } from './Icon';

export const InfoIcon = (props: IconProps) => (
    <Icon inheritColors={false} component={Svg} name="info" {...props} />
);
